import { forwardRef } from 'react';
import * as Styled from './Radio.styles';
import type { RadioProps } from './types';

const Radio = forwardRef<HTMLButtonElement, RadioProps>((props, ref) => (
  <Styled.Radio ref={ref} {...props} />
));

export default Radio;
